import Layout from '@/pages/Layout';

export default [
    {
        path: '/mySetting',
        redirect: 'noredirect',
        component: Layout,
        name: 'mySetting',
        meta: {
            title: '个人中心',
            icon: 'desktop'
        },
        children: [
            {
                path: 'updPwd',
                component: () => import('@/pages/mySetting/UpdPwd'),
                name: 'updPwd',
                id: 'mySetting/updPwd',
                meta: {
                    title: '密码设置',
                    icon: 'table'
                },
                isMenuWaterfall:true
            },
            {
                path: 'updFirstPage',
                component: () => import('@/pages/mySetting/UpdFirstPage'),
                name: 'updFirstPage',
                id: 'mySetting/updFirstPage',
                meta: {
                    title: '首页设置',
                    icon: 'table'
                },
                isMenuWaterfall:true
            },
            {
                path: 'baseInfoSetting',
                component: () => import('@/pages/mySetting/BaseInfoSetting'),
                name: 'baseInfoSetting',
                id: 'mySetting/baseInfoSetting',
                meta: {
                    title: '个人信息设置',
                    icon: 'table'
                },
                isMenuWaterfall:true
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-mySetting.js